import React from 'react'
import { Box, Typography, Button } from '@mui/material';
import { Info, UsersThree } from 'phosphor-react';
import useStyles from './NoTeamAdminModel.styles';

const NoTeamAdminModel = ({ handleClose, handleCreateTeam }) => {
    const classes = useStyles();
    return (
        <Box className={classes.container}>
            <div className={classes.infoContainer}>
                <Info size={24} color="#FF9F2D" />
                <Typography fontSize="24px" color="white" fontWeight={500}>Not a part of team</Typography>
            </div>
            <Typography color="white" fontWeight={400} style={{ margin: "16px 0px", fontSize: "14px" }}>To use Movie Colab Admin, you need to be a member of a Movie Colab Team. Either join an existing team or create a new one.</Typography>
            <div className={classes.endContainer}>
                <Button className={classes.outlineButton} onClick={handleClose}>Close</Button>
                <Button className={classes.filledButton} startIcon={<UsersThree />} onClick={handleCreateTeam}>Create a Team</Button>
            </div>
        </Box>
    )
}

export default NoTeamAdminModel
